import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core";
import { useStyles } from './MessageTableStyles';

// Helper function to count columns for a message
// Fields are directly on the message object (no nested data/columns)
// Only exclude header fields: id, timestamp, batchNumber, messageType
const countColumns = (message) => {
  const excludeFields = ["id", "timestamp", "batchNumber", "messageType"];
  return Object.keys(message).filter(
    key => !excludeFields.includes(key) && 
           message[key] !== undefined && 
           message[key] !== null && 
           message[key] !== ""
  ).length;
};

const MessageTable = ({ message, maxColumns }) => {
  const classes = useStyles();

  const getColumns = () => {
    // Only exclude header fields: id, timestamp, batchNumber, messageType
    // Include procedureNumber and all other fields in content
    const excludeFields = ["id", "timestamp", "batchNumber", "messageType"];
    
    // Map of field names to display column names
    const fieldToColumnMap = {
      "procedureNumber": "Procedure Number",
      "outletNumber": "Outlet Number",
      "cmoMaterialDescription": "CMO Material Description",
      "cmoMaterialCode": "CMO Material Code",
      "sponsorMaterialCode": "Sponsor Material Code",
      "cmoMaterialBatchNumber": "CMO Material Batch Number",
      "targetQuantity": "Target Quantity",
      "actualQuantity": "Actual Quantity",
      "parameter": "Parameter",
      "setPoint": "Set Point",
      "range": "Range",
      "actualValue": "Actual Value",
      "uom": "UOM",
      "methodNumber": "Method Number",
      "methodName": "Method Name",
      "dateOfSampling": "Date Of Sampling",
      "sampleID": "Sample ID",
      "sampleDescription": "Sample Description",
      "specificationLimit": "Specification Limit",
      "resultValue": "Result Value",
      "resultPassFail": "Result (Pass/Fail)",
      "deviationTitle": "Deviation Title",
      "dateOfDeviation": "Date Of Deviation",
      "assignedToRole": "Assigned To (Role)",
      "assignedToUser": "Assigned To (User)",
      "requireSponsorReviewSME": "Require Sponsor Review (SME)",
      "requireSponsorReviewQA": "Require Sponsor Review (QA)",
      "investigationNumber": "Investigation Number",
      "deviationStatus": "Deviation Status",
    };
    
    // Get all fields directly from message object
    return Object.keys(message)
      .filter(key => !excludeFields.includes(key) && message[key] !== undefined && message[key] !== null && message[key] !== "")
      .map(key => ({
        key: key,
        label: fieldToColumnMap[key] || key,
        value: message[key],
      }));
  };

  const columns = getColumns();

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell 
                key={col.key} 
                align="left" 
                className={classes.headerCell}
              >
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            {columns.map((col) => (
              <TableCell 
                key={col.key} 
                align="left" 
                className={classes.tableCell}
              >
                {col.value}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

// Export the countColumns function for use in parent components
export { countColumns };

export default MessageTable;

